// @flow

import React from 'react';

export default () => <div>Field Configurations</div>;
